(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5010],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fglossary%2Findex.tsx&page=%2Fglossary!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary",
      function () {
        return __webpack_require__("./src/pages/glossary/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/data/Constants.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ITEM_PER_PAGE; },
/* harmony export */   "L": function() { return /* binding */ WIKI_METADATA_VALUE_LIMIT; },
/* harmony export */   "Nf": function() { return /* binding */ FETCH_DELAY_TIME; },
/* harmony export */   "Vl": function() { return /* binding */ CATEGORY_DESCRIPTION_WORD_LIMIT; },
/* harmony export */   "a": function() { return /* binding */ WIKI_SUMMARY_LIMIT; },
/* harmony export */   "ag": function() { return /* binding */ WIKI_IMAGE_ASPECT_RATIO; },
/* harmony export */   "ft": function() { return /* binding */ MEDIA_POST_DEFAULT_ID; },
/* harmony export */   "hj": function() { return /* binding */ WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL; },
/* harmony export */   "xh": function() { return /* binding */ IMAGE_BOX_SIZE; }
/* harmony export */ });
/* unused harmony exports WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS, GPT3_COST_PER_1K_TOKENS, GPT3_MAX_TRIES */
const ITEM_PER_PAGE = 12;
const FETCH_DELAY_TIME = 3000;
const CATEGORY_DESCRIPTION_WORD_LIMIT = 200;
const MEDIA_POST_DEFAULT_ID = "UPLOADING_ID";
const WIKI_IMAGE_ASPECT_RATIO = 4 / 3;
const WIKI_METADATA_VALUE_LIMIT = 255;
const WIKI_SUMMARY_LIMIT = 255;
const WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL = 10 * 60 * 1000 // 10 Mins
;
const WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS = 5;
const GPT3_COST_PER_1K_TOKENS = 0.02;
const GPT3_MAX_TRIES = 3;
const IMAGE_BOX_SIZE = 150;


/***/ }),

/***/ "./src/pages/glossary/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_glossary; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
;// CONCATENATED MODULE: ./src/data/GlossaryAlphabetsData.ts
const glossaryAlphabetsData = [
    "#",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
];
const COMMONLY_SEARCHED_WIKIS = [
    "AltCoin",
    "Defi",
    "Coinbase",
    "BitCoin",
    "Hodl",
    "Collectibles",
    "ColdWallet",
    "por que"
];

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__("./node_modules/react-scroll/modules/index.js");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkOverlay.tsx
var LinkOverlay = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
;// CONCATENATED MODULE: ./src/components/Glossary/GlossaryWikiCard.tsx





const GlossaryWikiCard = (param)=>{
    let { highlightText , title , summary , wikiId  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
        as: "article",
        borderWidth: "1px",
        borderColor: "borderColorHover",
        overflow: "hidden",
        borderRadius: "12px",
        w: {
            base: "85%",
            md: "90%",
            lg: "70%"
        },
        p: "3",
        _hover: {
            bgColor: "tagHoverColor"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            cursor: "pointer",
            w: "full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                pb: "2",
                w: "full",
                px: "3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                        href: "/wiki/".concat(wikiId),
                        w: "full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            size: {
                                base: "sm",
                                lg: "md"
                            },
                            my: "10px",
                            color: "brand.500",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Highlight */.y$, {
                                query: highlightText,
                                styles: {
                                    px: "1",
                                    py: "1",
                                    bg: "carouselArrowBorderColor"
                                },
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSize: "md",
                        w: "full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Highlight */.y$, {
                            query: highlightText,
                            styles: {
                                px: "1",
                                py: "1",
                                bg: "brand.700",
                                color: "black",
                                _dark: {
                                    bg: "brand.300",
                                    color: "white"
                                }
                            },
                            children: summary.length > Constants/* WIKI_SUMMARY_LIMIT */.a ? summary.slice(0, Constants/* WIKI_SUMMARY_LIMIT */.a).concat("...") : summary
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Glossary_GlossaryWikiCard = (GlossaryWikiCard);

;// CONCATENATED MODULE: ./src/components/Glossary/GlossaryItems.tsx





const GlossaryItem = (param)=>{
    let { highlightText , glossary , glossaryAlphabets  } = param;
    const lettersIdentifier = /^[a-zA-Z]+$/;
    const cardOrder = (letter, alphabet)=>{
        const trimmedLetter = letter.trim();
        if (lettersIdentifier.test(trimmedLetter[0]) && trimmedLetter[0].toLocaleLowerCase() === alphabet.toLocaleLowerCase()) {
            return 1;
        }
        if (!lettersIdentifier.test(trimmedLetter[0]) && alphabet === "#") {
            return 2;
        }
        return 0;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
        w: "full",
        my: "7",
        children: glossaryAlphabets.map((item, i)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(dist_index_esm/* chakra.div */.m$.div, {
                id: item,
                pt: "50px",
                mt: "-20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                        name: item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            w: "full",
                            py: "1",
                            bg: "glossaryItemBg",
                            my: "4",
                            px: {
                                base: 8,
                                md: 10,
                                lg: "32"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: {
                                    base: "xl",
                                    lg: "4xl"
                                },
                                fontWeight: "bold",
                                children: item
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        justifyContent: "center",
                        alignItems: "center",
                        mb: "-40px",
                        mt: "30px",
                        direction: "column",
                        gap: "14",
                        children: glossary === null || glossary === void 0 ? void 0 : glossary.map((ob)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    cardOrder(ob.title, item) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Glossary_GlossaryWikiCard, {
                                        highlightText: highlightText,
                                        title: ob.title,
                                        summary: ob.summary,
                                        wikiId: ob.id
                                    }),
                                    cardOrder(ob.title, item) === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Glossary_GlossaryWikiCard, {
                                        highlightText: highlightText,
                                        title: ob.title,
                                        summary: ob.summary,
                                        wikiId: ob.id
                                    })
                                ]
                            }))
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ var GlossaryItems = (GlossaryItem);

// EXTERNAL MODULE: ./src/services/glossary/index.ts
var glossary = __webpack_require__("./src/services/glossary/index.ts");
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__("./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs");
;// CONCATENATED MODULE: ./src/components/Glossary/GlossaryHero.tsx



const GlossaryHero = /*#__PURE__*/ react.forwardRef((props, ref)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        direction: {
            base: "column",
            lg: "row"
        },
        justify: "space-between",
        px: {
            base: 3,
            lg: 10
        },
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
            w: "full",
            alignItems: "center",
            textAlign: "center",
            spacing: 3,
            my: 14,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                    w: "full",
                    fontSize: {
                        base: "32",
                        md: "42",
                        lg: "4xl"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* chakra.span */.m$.span, {
                            color: "brandLinkColor",
                            children: " IQ.WIKI"
                        }),
                        " Glossary"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                    w: {
                        base: "90%",
                        md: "80%",
                        xl: "90%"
                    },
                    fontSize: {
                        base: "sm",
                        md: "lg",
                        lg: "xl"
                    },
                    ref: ref,
                    children: [
                        "Crypto terminology can be difficult to figure out, especially if you‘re new to the blockchain. ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Here‘s a guide to help you navigate the exciting frontier of Web3."
                    ]
                })
            ]
        })
    }));
/* harmony default export */ var Glossary_GlossaryHero = (GlossaryHero);

;// CONCATENATED MODULE: ./src/components/Glossary/GlossaryAlphabets.tsx




const GlossaryAlphabets = (props)=>{
    const { shouldBeFixed , heightOfElement , item  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
        w: "100%",
        cursor: "pointer",
        textAlign: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
            activeClass: "active",
            to: item,
            spy: true,
            smooth: true,
            offset: shouldBeFixed ? -(heightOfElement || 284) : -(heightOfElement ? heightOfElement + 228 : 512),
            duration: 70,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: "semibold",
                fontSize: {
                    base: "md",
                    xl: "lg"
                },
                _hover: {
                    color: "brandLinkColor"
                },
                children: item
            })
        })
    });
};
/* harmony default export */ var Glossary_GlossaryAlphabets = (GlossaryAlphabets);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Glossary/GlossaryIconButton.tsx




const GlossaryIconButton = (param)=>{
    let { isVisible , setIsVisible  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
        width: "full",
        icon: isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronUpIcon */.g8, {
            fontSize: "28px",
            color: "linkColor",
            opacity: "0.5"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {
            fontSize: "28px",
            color: "linkColor",
            opacity: "0.5"
        }),
        "aria-label": "Toggle Text",
        onClick: ()=>setIsVisible(!isVisible),
        size: "xs",
        isRound: true,
        backgroundColor: "transparent",
        _hover: {
            backgroundColor: "#00000010"
        },
        _focus: {
            backgroundColor: "#00000010"
        },
        _active: {
            backgroundColor: "#00000010"
        }
    });
};
/* harmony default export */ var Glossary_GlossaryIconButton = (GlossaryIconButton);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/input/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tag/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Glossary/GlossaryFilterSection.tsx





const GlossaryFilterSection = (props)=>{
    var ref;
    const { searchText , searchPage , shouldBeFixed , setSearchText , activeIndex , setActiveIndex  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                w: "full",
                mb: shouldBeFixed ? 5 : 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, {
                    size: "md",
                    w: "full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputLeftElement */.Z8, {
                            ml: {
                                base: "15px",
                                xl: "unset"
                            },
                            pointerEvents: "none",
                            h: "full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* Search2Icon */.GV, {
                                color: "gray.300",
                                fontSize: {
                                    base: "sm",
                                    lg: "auto"
                                },
                                ml: {
                                    base: "-8",
                                    lg: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                            type: "tel",
                            placeholder: "Search for words",
                            value: searchText,
                            onChange: (e)=>searchPage(e.target.value),
                            _placeholder: {
                                color: "placeholderColor"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                my: "4",
                w: "full",
                wrap: "wrap",
                alignItems: "center",
                justifyContent: {
                    lg: "start",
                    "2xl": "center"
                },
                gap: {
                    base: "3",
                    "2xl": "10"
                },
                children: (ref = COMMONLY_SEARCHED_WIKIS.slice(0, 5)) === null || ref === void 0 ? void 0 : ref.map((word, i)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                        size: "lg",
                        bg: i === activeIndex ? "tagActiveBgColor" : "transparent",
                        color: i === activeIndex ? "tagActiveColor" : "tagColor",
                        cursor: "pointer",
                        borderRadius: "full",
                        borderWidth: "thin",
                        fontWeight: "normal",
                        fontSize: {
                            base: "sm",
                            lg: "md"
                        },
                        _hover: {
                            bgColor: "tagHoverColor"
                        },
                        onClick: ()=>{
                            setActiveIndex(i);
                            setSearchText(word);
                            searchPage(word);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* TagLabel */.Sn, {
                            children: word
                        })
                    }, word);
                })
            })
        ]
    });
};
/* harmony default export */ var Glossary_GlossaryFilterSection = (GlossaryFilterSection);

;// CONCATENATED MODULE: ./src/pages/glossary/index.tsx











const Glossary = ()=>{
    const [glossaryData, setGlossaryData] = (0,react.useState)({
        offset: 0,
        wikis: []
    });
    const { ref , entry  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0
    });
    const { ref: newRef , entry: newEntry  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0
    });
    const { data: fetchedGlossaryWikis  } = (0,glossary/* useGetGlossaryTagWikisQuery */.UH)({
        id: "Glossary",
        offset: glossaryData.offset,
        limit: 50
    });
    if (fetchedGlossaryWikis && (fetchedGlossaryWikis === null || fetchedGlossaryWikis === void 0 ? void 0 : fetchedGlossaryWikis.length) > 0) {
        setGlossaryData({
            offset: glossaryData.offset + 50,
            wikis: [
                ...glossaryData.wikis,
                ...fetchedGlossaryWikis
            ]
        });
    }
    const [searchText, setSearchText] = (0,react.useState)("");
    const shouldBeFixed = (entry === null || entry === void 0 ? void 0 : entry.intersectionRatio) !== undefined && !(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    const heightOfElement = ((newEntry === null || newEntry === void 0 ? void 0 : newEntry.boundingClientRect.height) || 96) + 68;
    const [isVisible, setIsVisible] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)();
    const [queryResult, setQueryResult] = (0,react.useState)();
    const [alphabet, setAlphabet] = (0,react.useState)(glossaryAlphabetsData);
    const filterGlossaryAlphabetBySearchResult = (searchResult, searchKeyword)=>{
        if (!searchKeyword) return glossaryAlphabetsData;
        if (!searchResult) return [];
        const filteredAlphabet = glossaryAlphabetsData.filter((currentAlphabet)=>searchResult.some((result)=>currentAlphabet === "#" ? /^\d/.test(result.title) : result.title.charAt(0).toLowerCase() === currentAlphabet.toLowerCase()));
        return filteredAlphabet;
    };
    const filterGlossaryBySearchQuery = (text)=>{
        var ref;
        const searchResult = glossaryData === null || glossaryData === void 0 ? void 0 : (ref = glossaryData.wikis) === null || ref === void 0 ? void 0 : ref.filter((wiki)=>wiki.summary.toLowerCase().includes(text.toLowerCase()) || wiki.title.toLowerCase().includes(text.toLowerCase()));
        const filteredAlphabet = filterGlossaryAlphabetBySearchResult(searchResult, text);
        setAlphabet(filteredAlphabet);
        setQueryResult(searchResult);
    };
    const searchPage = (input)=>{
        setSearchText(input);
        filterGlossaryBySearchQuery(input);
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
        direction: "column",
        w: "full",
        pb: "56",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glossary_GlossaryHero, {
                ref: ref
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                w: "full",
                ref: newRef,
                alignItems: "center",
                borderTop: "1px",
                mx: "auto",
                borderTopColor: "carouselArrowBorderColor",
                px: {
                    base: "9",
                    lg: "32"
                },
                top: shouldBeFixed ? "14" : "0",
                bg: "blogPageBg",
                position: shouldBeFixed ? "fixed" : "relative",
                zIndex: "sticky",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    mx: "auto",
                    w: "full",
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Grid */.rj, {
                            templateColumns: {
                                base: "repeat(9,1fr)",
                                md: "repeat(20,1fr)",
                                lg: "repeat(27,1fr)"
                            },
                            gap: 3,
                            py: "4",
                            children: glossaryAlphabetsData.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Glossary_GlossaryAlphabets, {
                                    item: item,
                                    heightOfElement: heightOfElement,
                                    shouldBeFixed: shouldBeFixed
                                }, i))
                        }),
                        !shouldBeFixed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Glossary_GlossaryFilterSection, {
                            setSearchText: setSearchText,
                            shouldBeFixed: shouldBeFixed,
                            searchText: searchText,
                            searchPage: searchPage,
                            activeIndex: searchText === "" ? undefined : activeIndex,
                            setActiveIndex: setActiveIndex
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Glossary_GlossaryFilterSection, {
                                    setSearchText: setSearchText,
                                    shouldBeFixed: shouldBeFixed,
                                    searchText: searchText,
                                    searchPage: searchPage,
                                    activeIndex: searchText === "" ? undefined : activeIndex,
                                    setActiveIndex: setActiveIndex
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Glossary_GlossaryIconButton, {
                                    isVisible: isVisible,
                                    setIsVisible: setIsVisible
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlossaryItems, {
                highlightText: searchText,
                glossary: (ref1 = queryResult !== null && queryResult !== void 0 ? queryResult : glossaryData === null || glossaryData === void 0 ? void 0 : glossaryData.wikis) !== null && ref1 !== void 0 ? ref1 : [],
                glossaryAlphabets: alphabet
            })
        ]
    });
};
/* harmony default export */ var pages_glossary = (Glossary);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7843,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fglossary%2Findex.tsx&page=%2Fglossary!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);